import React, { useState, useContext } from 'react';
import { Button, Checkbox, Tooltip, Whisper } from 'rsuite';
import './add-bm.scss';
import { default as t } from '../../../../utils/i18n';
import {
  ActionLink,
  ModalWindow,
  Input,
  Dropdown,
  CommonToaster,
  EmailTooltip,
} from '../../../atoms';
import { UserContext, ToasterContext } from '../../../../context';
import { AdminService } from '../../../../services';
import { ReactComponent as InfoIcon } from '../../../../assets/svg/icon_info_sign.svg';
import { toast } from 'react-toastify';
import ToastContainer from 'rsuite/esm/toaster/ToastContainer';

function AddBm({ addAccountsModal, setAddAccountsModal, handleOnAdd, bmOptions, toasterDetails }) {
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [token, setToken] = useState('');
  const [errorData, setErrorData] = useState('');
  const { message, setMessage } = useContext(ToasterContext);
  const [toaster, setToaster] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [bmDetailResponse, setBmDetailResponse] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const handleOnCancel = e => {
    e.preventDefault();
    setAddAccountsModal(false);
    setMessage({});
    setToaster(false);
    clearToaster();
  };

  const onAdd = async () => {
    const payload = {
      id: selectedOption?.label,
      name: bmDetailResponse?.businessName,
      isOnboarded: true,
      isOverriddenToken: isChecked,
      token,
    };
    try {
      const bmResponse = await AdminService.updateBmDetails(
        userAccessToken,
        username,
        payload,
        payload?.id
      );
      toasterDetails({ message: t('bm.added'), isError: false });
      setToaster(true);
      // clearToaster();
      handleOnAdd();
    } catch (error) {
      if (error?.data?.data?.code === 'INVALID_REQUEST') {
        toasterDetails({ message: error?.data?.data?.message, isError: true });

        setToaster(true);
        return;
      }
      const dataCode = error?.data?.data?.code;
    } finally {
      setAddAccountsModal(false);
    }
  };

  const clearToaster = () => {
    setTimeout(() => {
      console.log('clear called');
      setToaster(false);
    }, 7000);
  };

  const getAccountDetail = async accountId => {
    try {
      const bmResponse = await AdminService.getBusinessAccountDetails(
        userAccessToken,
        username,
        accountId
      );
      setBmDetailResponse(bmResponse?.data?.data);
      const { businessName, token, isOverriddenToken = false } = bmResponse?.data?.data || {};
      if (businessName) {
        setName(businessName);
      }
      if (isOverriddenToken) {
        setIsChecked(true);
        setToken(token);
      }
    } catch (error) {}
  };

  const handleOnSelect = e => {
    setToken('');
    setSelectedOption(e);
    getAccountDetail(e.value);
    setErrorData('');
    setIsChecked(false);
  };

  return (
    <div>
      <div className="attr-delete accounts-add-container">
        <ModalWindow
          className="fqa-modal--addAccounts add-bm"
          isOpen={addAccountsModal}
          onRequestClose={handleOnCancel}
          heading={t('Add Business Manager')}
          ariaHideApp={false}
          appElement={document.getElementById('app')}
        >
          <div>
            <div className="input-container add_bm">
              <div className='add_bm-tooltip'>

              <span className="bm-id-dd">
                Business Id <sup>*</sup>
              </span>
               <EmailTooltip
                  emailToolTip="Only Business Managers that have been onboarded to OneSocial are available to onboard or update"
                  place={'right'}
                  />
                  </div>
              <Dropdown
                className="user-select"
                value={selectedOption}
                options={bmOptions}
                onSelect={handleOnSelect}
                placeholder={'Please select a Business Id'}
              />

              <Input
                labelValue={t('admin.bm.add.businessName')}
                name="name"
                fieldType="text"
                placeholder={t('admin.bm.add.businessName')}
                value={name}
                handleChange={e => setName(e?.target?.value)}
                disabled={true}
              />

              <hr/>
              <p id='info-tooltip-text'>Tick to use a custom token. Untick to revert to the default UPA token.</p>
              <div className="tooltip-checkbox">
               
                <Checkbox checked={isChecked} onChange={() => setIsChecked(!isChecked)}>
                  I understand this will overwrite the current token.
                </Checkbox>
              </div>
              {isChecked ? (
                <Input
                  labelValue={t('admin.bm.add.token')}
                  name="token"
                  fieldType="textArea"
                  placeholder={t('admin.bm.add.token')}
                  value={token}
                  handleChange={e => setToken(e?.target?.value)}
                />
              ) : null}
            </div>
          </div>
          {errorData && <div className="error">{errorData}</div>}
          <div className="fqa-model-pa--actions">
            <ActionLink
              anchor={true}
              redirectTo={''}
              value={t('admin.add.close')}
              handleClick={handleOnCancel}
            />
            <Button
              className="fqa-model-pa--actions-confirm delete-button"
              name="submit"
              onClick={onAdd}
            >
              {t('admin.cta.add.account')}
            </Button>
          </div>
        </ModalWindow>
      </div>
    </div>
  );
}
export default AddBm;
